import config from './config';
import { CACHE_BUST_CONTENT } from './env/public';

/** General content configuration unrelated to the specific content service. */
const content = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /** The main service used by the Content component. */
      service: 'builder',
      /** Whether preview is enabled or not. */
      enablePreview: { default: true, prod: false },
      /**
       * The revalidation period for content in seconds, since this is used in static revalidation
       * using the pages router the value can never be 0. It would be false.
       */
      revalidate: { default: 1, prod: 7200 },
      /**
       * The revalidation period for content in seconds used for a cache on the service.
       * This has been made separate from the static revalidation since they have different
       * possible values.
       *
       * TODO: These should be combined as we move forward with the app router.
       */
      dynamicRevalidate: { default: 30, prod: 3600 },

      /**
       * The revalidation period for content in seconds used for a cache on the client.
       */
      clientRevalidate: { default: 30, prod: 300 },
      /**
       * If the content is expected not to be null and it returns null then the revalidate
       * is set to a lower value in seconds.
       */
      dynamicRevalidateFail: { default: 10, prod: 120 },
      /** The image quality to use when setting content images. */
      imageQuality: 75,
      /** The video quality to use when setting content videos. */
      videoQuality: 80,
      /** Whether to always cache bust content. This is only for the cache in 
       * builder.io, we will still cache the content ourselves in multiple ways. 
       */
      alwaysCacheBustContent: CACHE_BUST_CONTENT,
    }
  }
});

export default content;
